'use client';

import { cn } from '@/lib/utils';
import type { FlatRule } from './search';

export interface SidebarGroup {
  key: string;
  title: string;
  rules: FlatRule[];
}

export default function RulesSidebar({
  groups,
  activeSlug,
  onSelect,
}: {
  groups: SidebarGroup[];
  activeSlug: string;
  onSelect: (slug: string) => void;
}) {
  return (
    <nav
      data-ui="rules-v3.sidebar"
      aria-label="Rules"
      className="sticky top-[5rem] flex w-[33rem] shrink-0 flex-col gap-[4rem] rounded-[0.75rem] border border-black/[0.08] bg-white px-[1.375rem] pb-[2.25rem] pt-[3rem]"
    >
      {groups.map((group) => (
        <div key={group.key} data-ui={`sidebar.group.${group.key}`} className="flex w-full flex-col gap-[1rem]">
          {group.title && (
            <p data-ui="sidebar.group-title" className="mb-0 px-[1.5rem] font-geist text-[2rem] font-medium uppercase leading-[3rem] text-black/40">
              {group.title}
            </p>
          )}
          <ul className="m-0 flex w-full list-none flex-col gap-[0.25rem] p-0">
            {group.rules.map((rule) => {
              const active = rule.slug === activeSlug;
              return (
                <li key={rule.slug} className="w-full">
                  <button
                    type="button"
                    data-ui={active ? 'sidebar.item.active' : 'sidebar.item'}
                    onClick={() => onSelect(rule.slug)}
                    aria-current={active ? 'page' : undefined}
                    className={cn(
                      'relative flex h-[4.5rem] w-full items-center overflow-hidden rounded-[0.25rem] px-[1.5rem] text-left font-geist text-[2rem] leading-[3rem] transition-colors',
                      active
                        ? 'bg-[#f2f4f3] font-medium text-black'
                        : 'font-normal text-black/[0.64] hover:bg-[#f2f4f3]/60 hover:text-black',
                    )}
                  >
                    {active && (
                      <span className="absolute inset-y-0 left-0 w-[0.25rem] bg-[#228e71]" aria-hidden />
                    )}
                    <span className="truncate">{rule.title}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}
